export function dsAfterCompile(funcion, time=30000) {
  setTimeout(() => {
    funcion();
  }, time);
}